import DashboardLayout from '@pma/app/dashboard/layout'

import { Card, CardContent } from '@pma/components/common/card'
import { PriceListCards } from '@pma/components/financials/price-lists-cards-list'

const PriceListsPage = () => {
  return (
    <DashboardLayout>
      <Card className='relative mt-2 max-w-full overflow-x-auto border-none p-2 md:p-4 shadow-none'>
        <CardContent className='mt-0 h-auto min-h-[50vh] w-full overflow-x-hidden p-0'>
          <PriceListCards />
        </CardContent>
      </Card>
    </DashboardLayout>
  )
}

export default PriceListsPage
